import { render, staticRenderFns } from "./Finalizado.vue?vue&type=template&id=d018384c&scoped=true&"
import script from "./Finalizado.vue?vue&type=script&lang=js&"
export * from "./Finalizado.vue?vue&type=script&lang=js&"
import style0 from "./Finalizado.vue?vue&type=style&index=0&id=d018384c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d018384c",
  null
  
)

export default component.exports